import { css } from "styled-components";

import FactorALight from '../assets/fonts/FactorA/Factor-A-Light.ttf';
import FactorALightItalic from '../assets/fonts/FactorA/Factor-A-LightItalic.ttf';
import FactorARegular from '../assets/fonts/FactorA/Factor-A-Regular.ttf';
import FactorARegularItalic from '../assets/fonts/FactorA/Factor-A-RegularItalic.ttf';
import FactorAMedium from '../assets/fonts/FactorA/Factor-A-Medium.ttf';
import FactorAMediumItalic from '../assets/fonts/FactorA/Factor-A-MediumItalic.ttf';
import FactorABold from '../assets/fonts/FactorA/Factor-A-Bold.ttf';
import FactorABoldItalic from '../assets/fonts/FactorA/Factor-A-BoldItalic.ttf';
import FactorAExtraBold from '../assets/fonts/FactorA/Factor-A-Extrabold.ttf';
import FactorAExtraBoldItalic from '../assets/fonts/FactorA/Factor-A-ExtraboldItalic.ttf';

export const fontWeight = {
  textRegular: 400,
  textMedium: 500,
  textBold: 700,
}

export const FontFamily = css`

  @font-face {
    font-family: 'Factor A';
    src: url(${FactorALight}) format("truetype");
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorALightItalic}) format("truetype");
    font-weight: 300;
    font-style: italic;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorARegular}) format("truetype");
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorARegularItalic}) format("truetype");
    font-weight: 400;
    font-style: italic;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorAMedium}) format("truetype");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorAMediumItalic}) format("truetype");
    font-weight: 500;
    font-style: italic;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorABold}) format("truetype");
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorABoldItalic}) format("truetype");
    font-weight: 600;
    font-style: italic;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorAExtraBold}) format("truetype");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Factor A';
    src: url(${FactorAExtraBoldItalic}) format("truetype");
    font-weight: 700;
    font-style: italic;
    font-display: fallback;
  }
`;

